import { StepConnector, stepConnectorClasses, styled } from "@mui/material";
import { Colors } from "Components/Layout/Themes/Colors";

type Props = {
  isActive: boolean;
};

export const Connector = styled(StepConnector, {
  shouldForwardProp: (prop) => prop !== "isActive",
})<Props>(({ theme, isActive }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: "calc(-50% + 16px)",
    right: "calc(50% + 16px)",
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: isActive ? theme.palette.primary.main : Colors.MediumGrey,
    borderTopWidth: 2,
    borderRadius: 1,
    ...theme.applyStyles("dark", {
      borderColor: isActive
        ? theme.palette.primary.main
        : theme.palette.grey[800],
    }),
  },
}));
